import apiService from 'frontcore/data/api-service/api-service'
import { DropDownMenuItemProps } from 'frontcore/views/drop-down/domain/types'
import { RemoteFiltersConfiguration, RemoteFiltersFieldType } from 'frontcore/presentation/remote-filters/domain/types'

type RemoteFilterConfigurationAPIResponse = {
  component_props: Record<string, unknown>
  default_option: number | boolean | string[] | number[]
  filter_id: string
  filter_type: RemoteFiltersFieldType
  filter_map: string
  label: string
  modules?: string[]
  options: DropDownMenuItemProps[]
  related_filters: string[]
  required: boolean,
  reload_filters_when_update_value: boolean,
}[]

class RemoteFiltersAPIService {
  path: string

  constructor (path: string) {
    this.path = path
  }

  private parseDefaultOption (filterType: RemoteFiltersFieldType, defaultOption: RemoteFiltersConfiguration['defaultOption']): RemoteFiltersConfiguration['defaultOption'] {
    switch (filterType) {
    case RemoteFiltersFieldType.DATE:
      if (typeof defaultOption !== 'string') {
        return undefined
      }
      return new Date(defaultOption)
    case RemoteFiltersFieldType.DATE_RANGE:
      if (Array.isArray(defaultOption) && defaultOption.every(option => !isNaN(new Date(option).getTime()))) {
        return defaultOption.map(option => new Date(option))
      }
      return []
    default:
      return defaultOption
    }
  }

  async fetch (queryParams: object) {
    const response = await apiService
      .buildRequest()
      .withSessionToken()
      .withQueryParameters({ ...queryParams })
      .get<RemoteFilterConfigurationAPIResponse>(this.path)
    return response.data.map<RemoteFiltersConfiguration>(datum => ({
      componentProps: datum.component_props,
      defaultOption: this.parseDefaultOption(datum.filter_type, datum.default_option),
      filterId: datum.filter_id,
      filterMap: datum.filter_map,
      filterType: datum.filter_type,
      label: datum.label,
      modules: datum.modules,
      options: datum.options,
      relatedFilters: datum.related_filters,
      required: datum.required,
      reloadFiltersWhenUpdateValue: datum.reload_filters_when_update_value,
    }))
  }
}

export default RemoteFiltersAPIService
